import React, { useState, useEffect, useContext } from "react";
import {graphql, navigate, useStaticQuery} from "gatsby";

import { AppBar, Toolbar, IconButton, Grow } from "@mui/material";

import DialpadIcon from '@mui/icons-material/Dialpad';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ListIcon from '@mui/icons-material/List';

import LanguageSelector from "./LanguageSelector";

import MainMenu from "./Menu"

import { GlobalContext } from "./GlobalContext";

import Root, { classes } from "./styles/menu";

const TopBar = (props) => {

    const { keypadSwitch, onKeypad, keypadShown, showBackbutton = true, title = "Root", transparentAppbar = false, } = props;
    const { fullscreenMode , moduleRepository} = useContext(GlobalContext);

    /** moduleRepository is only available if rendered in global context. This is not the case
     *  for 404 pages, so we need to check if it exists.
     */
    const { keypadButton: keypadButtonStyles } = moduleRepository?.getStyles(props.entity?.module?.name) || {};

    const [showTopbar, setShowTopbar] = useState(!fullscreenMode);
    const { allStrapiAppSettings: settings, allStrapiEntities: entities } = useStaticQuery(staticQuery);

    const onClick = (e) => {
        setShowTopbar(!showTopbar);
    };

    const doNotToggleTopBar = (e) => {
        e.stopPropagation();
    }

    useEffect(() => {
        if (fullscreenMode) {
            document.body.removeEventListener("click", onClick);
            document.body.addEventListener("click", onClick);
            return () => document.body.removeEventListener("click", onClick);
        } else {
            document.body.removeEventListener("click", onClick);
        }
    }, [fullscreenMode, showTopbar]);


    const hideBackButton = showBackbutton ? {} : { style: { display: 'none' } };//TODO - useEffect/State to be correct

    const barStyle = { style: {} };
    if (transparentAppbar) barStyle.style.backgroundColor = 'transparent';

    const Menu = props.menu || MainMenu;
    const Wrap = fullscreenMode ? Grow : React.Fragment;
    const wrapProps = fullscreenMode ? { in: !showTopbar } : {};

    return (
        <Root>
            <Wrap {...wrapProps} >{/* - TODO - cms - should be configurable, maybe super-modular dynamic-zone setting... */}
                <AppBar className={classes.appBar} {...barStyle} onClick={doNotToggleTopBar}>
                    <Toolbar className={classes.toolbar}>
                        <IconButton
                            {...hideBackButton}
                            edge="start"
                            color="inherit"
                            aria-label="backbutton"
                            onClick={() => {
                                document.body.style.overflow = "auto";
                                navigate(-1);
                            }}
                            size="large">
                            <ArrowBackIcon />
                        </IconButton>
                        {/* TODO - make configurable - headline in center
                    <Typography variant="h6" className={classes.centered} align="center">
                        {title}
                    </Typography>
                    */}
                        {keypadSwitch === true && (
                            <IconButton
                                sx={{ ...keypadButtonStyles }}
                                className={classes.centered}
                                align="center"
                                color="inherit"
                                aria-label="keypad"
                                onClick={onKeypad}
                                size="large">
                                {keypadShown ? <ListIcon /> : <DialpadIcon />}
                            </IconButton>)
                        }
                        <div className={classes.rightItems}>
                            <LanguageSelector {...props} />
                            <Menu {...props} settings={settings} entities={entities} />

                            {/*keypadSwitch && TODO - make configurable
                            <IconButton edge="end" className={classes.riughtMenuButton} color="inherit" aria-label="keypad" onClick={onKeypad} >
                                {keypadShown ? <ListIcon /> : <DialpadIcon />}
                            </IconButton>
                        */}


                        </div>
                    </Toolbar>
                </AppBar>
            </Wrap>
            {fullscreenMode !== true && <div className={classes.toolbarMargin} />}
        </Root>
    );
}

export default TopBar;

const staticQuery = graphql`
    query {
                allStrapiAppSettings {
                    nodes {
                        Topbar {
                            backgroundColor
                            fontColor
                            entities {
                                identifier
                                title
                                locale
                            }
                            linkToStartpage
                        }
                    }
                }
                allStrapiEntities {
                    nodes {
                        identifier
                        title
                        locale
                    }
                }
            }
    `;
